export const datePickerFormat = (date: Date): string => {
  try {
    return date.toISOString().slice(0, 10);
  } catch (error) {
    return error.message;
  }
};
